module.exports = __webpack_public_path__ + "img/CustomerActivities - Scan History Map Button.c35bf5c5.svg";